"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconRmaSolid = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconRmaSolid = function IconRmaSolid(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24 24h-1.406c0-6.334-5.152-11.487-11.485-11.487h-.234v5.48L0 8.995 10.875 0v5.497C18.169 5.861 24 11.884 24 19.313V24z",
    fillRule: "evenodd"
  }));
};
exports.IconRmaSolid = IconRmaSolid;